import styled from 'styled-components'

export const Image = styled.img`
  width: 100%;
  max-width: 150px;
  margin-bottom: 16px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    width: 100%;
    max-width: 250px;
  }
`

export const EmptyStateContainer = styled.div`
  margin: 40px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: 627px;
  padding: 16px;
`

export const Heading = styled('div')`
  margin-bottom: 16px;
  text-align: center;
`

export const Subtitle = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey84};
  line-height: 20px;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    font-size: 18px;
    line-height: 24px;
  }
`
